import * as Home from '../constants/Home';
import axios from 'axios';

import * as SG from '../constants/AppSettings';
// import { loadStart, loadEnd, noticeAdd } from './App';

// コミュニティ読み込み
export function getCommunities() {
  return dispatch => {
    dispatch(communityLoadStart())
    
    axios.get(SG.COMMUNITY_INDEX_URL ,{
        'headers': {
          'Authorization': localStorage.getItem('token')
        }
      }).then(res => {
      dispatch(getCommunitiesResult(res.data.communities))
      dispatch(communityLoadEnd())
      return {
        type: Home.GET_COMMUNITIES
      }
    }).catch(res => {
      dispatch(communityLoadEnd())
      return {
        type: Home.GET_COMMUNITIES
      }
    })
  }
}

export function getCommunitiesResult(communities) {
  return {
    type: Home.GET_COMMUNITIES_RESULT,
    communities
  }
}

export function communityLoadStart() {
  return {
    type: Home.COMMUNITY_LOAD_START
  }
}

export function communityLoadEnd() {
  return {
    type: Home.COMMUNITY_LOAD_END
  }
}


// WEBPACK FOOTER //
// ./src/actions/Home.js